import type { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

import { cn } from '@/shared/lib/cn';
import { PageHeader } from '@/shared/ui/PageHeader';

import { PlatformEmailSection } from './PlatformEmailSection';

/**
 * Secoes de Configuracoes da administracao da plataforma.
 *
 * Cada secao e uma configuracao da instalacao inteira, e nao de uma empresa (essas
 * ficam no detalhe da empresa). A primeira e o E-mail (ADR 0096); uma secao nova entra
 * com uma linha aqui, uma rota em `rotas.tsx` e o componente dela.
 */
const secoes = [
  {
    chave: 'email',
    to: '/admin/configuracoes/email',
    label: 'E-mail',
    descricao: 'Servidor e remetente dos e-mails da plataforma',
  },
] as const;

export type SecaoDeConfiguracao = (typeof secoes)[number]['chave'];

const conteudo: Record<SecaoDeConfiguracao, () => ReactElement> = {
  email: () => <PlatformEmailSection />,
};

export function PlatformConfiguracoesPage({ secao }: { secao: SecaoDeConfiguracao }) {
  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Configuracoes da plataforma"
        description="Configuracoes da instalacao inteira, alteradas so pela administracao da plataforma."
      />
      <div className="grid gap-5 lg:grid-cols-[220px_1fr]">
        <nav aria-label="Secoes das configuracoes" className="flex flex-col gap-1">
          {secoes.map((item) => (
            <NavLink
              key={item.chave}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'flex flex-col rounded-md px-3 py-2 text-sm',
                  isActive
                    ? 'bg-brand-50 font-semibold text-brand-700'
                    : 'text-ink-700 hover:bg-ink-50',
                )
              }
            >
              {item.label}
              <span className="text-2xs font-normal text-ink-500">
                {item.descricao}
              </span>
            </NavLink>
          ))}
        </nav>
        <div>{conteudo[secao]()}</div>
      </div>
    </div>
  );
}
